export default import.meta.ROLLDOWN_FILE_URL_9Tvcej7Vn4Z5qzWbOEh35w